import classes from './LinkCard.module.scss';

const LinkCard = ({ link, image, title, description, githubLink }) => {

  return (
    <div className={`${classes["link-card"]}`}>
      <div className={classes.image}>
        <img src={image} alt={title} />
      </div>
      <div className={classes["overlay-text"]}>
        <h3 className="title">{title}</h3>
        <p className="desc">{description}</p>
        <div className={classes.links}>
          <a className="btn" href={link} rel="noreferrer" target="_blank">
          <i className='icon icon-new-window'></i>
            <span>Visit</span>
          </a>
          <a className="btn" href={githubLink} rel="noreferrer" target="_blank">
            <i className='icon icon-github'></i> 
            <span>Github</span>
          </a>
        </div>
      </div>
      
    </div>
  )
}

export default LinkCard;